export default "__VITE_PUBLIC_ASSET__ed81b775__"